import React, { useState } from 'react';
import TextWinds from '../common/TextWinds';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { Collapse } from '@material-tailwind/react';
import { numberWithCommas } from '../../api/utils/format/numbers';
import Buttons from '../common/Buttons';
import PurchaseSummary from './PurchaseSummary';

interface AmountPaymentProps {
  productAmount: number;
  deliveryAmount: number;
  discountAmount: number;
  pointAmount: number;
  handlePurchase: () => void;
  isValid: boolean;
}

/**
 * 결제 페이지 서브 패널 - 결제 금액, 결제 버튼
 * @param productAmount 상품 금액
 * @param deliveryAmount 배송비
 * @param discountAmount 제품 할인 금액
 * @param pointAmount 포인트 사용 금액
 * @param handlePurchase 결제 요청
 * @param isValid 결제 가능 여부 (유효성 + 약관 동의 포함)
 */
const AmountPayment = React.memo(
  ({
    productAmount,
    deliveryAmount,
    discountAmount,
    pointAmount,
    handlePurchase,
    isValid,
  }: AmountPaymentProps) => {
    const [isPurchaseInfoOpen, setIsPurchaseInfoOpen] = useState(true);

    const salePrice = discountAmount + pointAmount;
    const orderPrice = productAmount + deliveryAmount;
    const totalPrice = orderPrice - salePrice;
    return (
      <div className="relative mt-[30px] h-fit w-full rounded-md bg-gray0 px-[20px] py-[14px] shadow-none xl:mt-0 xl:rounded-[8px] xl:bg-white">
        <TextWinds type="title_h4">결제 금액</TextWinds>
        <div className="flex flex-row justify-between">
          <div className="flex flex-row items-center justify-between pt-[10px]">
            <TextWinds
              type="title_h3"
              color="purple5"
              className="flex items-center gap-[5px]"
            >
              {numberWithCommas(totalPrice)}
            </TextWinds>
            <TextWinds type="content_body4">원</TextWinds>
          </div>
          <div className="flex items-center">
            <ChevronDownIcon
              strokeWidth={2.5}
              className={`h-5 w-5 transition-transform ${
                isPurchaseInfoOpen ? 'rotate-180' : ''
              }`}
              onClick={() => setIsPurchaseInfoOpen((cur) => !cur)}
            />
          </div>
        </div>
        <div>
          <div className="my-[16px] border border-t-[1px] border-gray4" />
          <Collapse open={isPurchaseInfoOpen}>
            <PurchaseSummary
              productAmount={productAmount}
              deliveryCharge={deliveryAmount}
              discountAmount={discountAmount}
              pointAmount={pointAmount}
            />
          </Collapse>
        </div>
        <div className="p-4 xl:px-0">
          <Buttons
            type="filled"
            color="purple5"
            disabled={!isValid}
            onClick={handlePurchase}
          >
            결제하기
          </Buttons>
        </div>
      </div>
    );
  },
);

export default AmountPayment;
